module.exports = __webpack_public_path__ + "images/statisticthumb1.png";


//////////////////
// WEBPACK FOOTER
// ./src/images/statisticthumb1.png
// module id = fvcQ
// module chunks = 1 2 3 4 5 6 7 8 9 10 11 12 13